export { default } from './Main'
export * from './Main'



// WEBPACK FOOTER //
// ./src/containers/Main/index.ts